export const TEXTS = {
  COUPON_HEADER_TITLE: 'Coupons',
  COPY: 'Copy',
  COPY_CODE: 'Copy Code',
  OKAY: 'Okay',
  APPLY: 'Apply',
  APPLIED: 'APPLIED',
  VIEW_MORE: 'View More',
  VIEW_LESS: 'View Less',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  APPLY_AND: 'Apply and ',
  SAVE: 'save ',
  CANCEL: 'Cancel',
  COUPON_SAVINGS: 'Coupon Savings',
  VIEW_BAG: 'View Bag',
  COUPONS_IMAGE: 'coupon Image',
  YOU_SAVED: 'You saved',
  REMOVE: 'Remove',
  DETAILS: ' see details',
  DISMISS: 'Dismiss',
  SAVE_OFFER: 'Save ',
  BACK: 'Back',
};

export const APPLICABLE_COUPONS_PROPS = {
  title: 'Ready to Apply',
  subtitle: 'Apply one of these Coupons to save extra',
  key: 'Ready to Apply',
  className: 'couponsRendered',
  disabled: false,
};

export const NON_APPLICABLE_COUPONS_PROPS = {
  title: 'Shop More to Apply ',
  subtitle: 'Almost there! Shop more to save extra',
  key: 'Non Applicable Coupons',
  className: 'couponsRendered',
  disabled: false,
  showViewProduct: true,
};

export const REMOVE_AND_APPLY_COUPONS_PROPS = {
  actionName: 'Remove and Apply',
  title: 'Remove and Apply',
  subtitle: 'Are you sure you want to remove <old> and apply <new>',
};

export const REMOVE_COUPON_PROPS = {
  actionName: 'Remove',
  title: 'Remove Coupon',
  subtitle: 'If you remove the Coupon, you will lose out on the offer applied too',
};

export const EMPTY_PAGE = {
  title: 'Uh-Oh!',
  subtitle: 'You seem to have no Coupons. Please try again after some time.',
  actionName: 'Ok, Got it',
};

export const ERROR_PAGE = {
  title: 'Something went wrong',
  subtitle: 'Oops! Something seems broken here. Come back later & try again.',
  actionName: 'Try Again',
};

export const BUTTON_TYPE = {
  APPLY: 'apply',
  COPY: 'copy',
};

export const COUPON_CODE_COPIED_TEXT = {
  SUCCESS: 'Coupon code copied successfully',
  FAILED: 'Copying coupon code failed!',
};

export const EMPTY_COUPON_DATA = {
  couponCode: '',
  couponId: -1,
  title: '',
  subTitle: '',
  description: '',
  couponTncUrl: '',
  freebies: [],
  imageUrl: '',
  prive: false,
  subtitle: '',
  tnc: [],
  discount: -1,
  disabled: false,
};

export const LOGIN_BANNER_IMAGE_ALT = 'Login Banner Image';
export const COUPON_EXPIRY_REMOTE_CONFIG = 'couponExpiry';
